import { Loader2 } from 'lucide-react';
import { cn } from '@/lib/utils';

export interface SpinnerProps {
  className?: string;
  label?: string;
  size?: 'sm' | 'md' | 'lg';
}

const sizeMap = { sm: 'h-3.5 w-3.5', md: 'h-4 w-4', lg: 'h-6 w-6' };

export function Spinner({ className, label = 'Завантаження…', size = 'md' }: SpinnerProps) {
  return (
    <span
      role="status"
      aria-label={label}
      className={cn('inline-flex items-center gap-2 text-muted-foreground', className)}
    >
      <Loader2 className={cn('animate-spin', sizeMap[size])} aria-hidden />
    </span>
  );
}
